import type { CSSProperties } from 'react';
import { useContext } from 'react';
import { X } from 'react-feather';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context';
import { useToggleUploadDisplay, useUploadInProgress } from '@trinity/chat-components/containers/WorkspaceFileUpload/hooks';
import { formatPlurality } from '@trinity/chat-components/utils';
import { HeaderHeight } from './consts';
import styles from './style/Header.module.css';

export const FileUploadsHeader = () => {
  const state = useContext(FileUploadsStateContext);
  const toggle = useToggleUploadDisplay();
  const inProgress = useUploadInProgress();

  const count = state.invalid.length + state.valid.length;

  const text = !inProgress
    ? 'Upload Completed'
    : `Uploading ${count} ${formatPlurality('file', count)}`;

  const headerStyle: CSSProperties = {
    height: HeaderHeight,
  };

  return (
    <div className={styles.root} style={headerStyle}>
      <div>{text}</div>
      <Tooltip title="Close" arrow={false}>
        <div className={styles.close} onClick={toggle}>
          <X />
        </div>
      </Tooltip>
    </div>
  );
};

export default FileUploadsHeader;